const routes = [
    {
        path: "/advising",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentprogram_advisorstudents"
        }
    }
];

export default routes;
